import { Injectable } from '@angular/core';
import { RequestBase } from './request-base';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class StoredProcedureService extends RequestBase {
    BasePath = 'api/storedprocedure';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetStoredProcedures(datasource): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetStoredProcedures?datasource=' + datasource, this.options);
    }
}
